<template>
  <v-data-table
    :items="getItems.filter(x => x.ratio !== null && x.ratio < 110)"
    :headers="headers"
    :items-per-page="itemPerPage"
    hide-default-footer
    sort-by="ratio"
    :sort-desc="false"
    dense
    :loading="loading"
  ></v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "InventoryWarningGrid",
  props: {
    itemPerPage: {
      type: Number,
      default: 5
    }
  },
  computed: {
    ...mapGetters([
      "getInventoryRecords",
      "getPreparationSlipTemplates",
      "getProducts"
    ]),
    getItems() {
      return this.getInventoryRecords
        .map(record => {
          const product = this.getProducts.find(
            p => p.id === record.fk_product
          );
          const preparation_slip_template_products = this.getPreparationSlipTemplates
            .map(slip => slip.preparation_slip_template_products)
            .flat()
            .filter(p => p.fk_product === record.fk_product);
          let min = Math.max(
            ...preparation_slip_template_products.map(x => Number(x.quantity))
          );
          min = Number.isNaN(min) || !Number.isFinite(min) ? 0 : min;
          const diff = min - Number(record.computedQuantity);
          if (product) {
            return {
              name: product.nom,
              min,
              qty: Number(record.computedQuantity),
              diff: diff > 0 ? diff : "",
              ratio:
                min != 0 ? (Number(record.computedQuantity) / min) * 100 : null,
              unit: product.data ? product.data.unite_mesure_inventory : ""
            };
          } else {
            return null;
          }
        })
        .filter(x => x !== null);
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      headers: [
        { value: "name", text: "" },
        { value: "min", text: "Min." },
        { value: "qty", text: "Qté." },
        { value: "diff", text: "Manque" },
        { value: "unit", text: "" }
      ]
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await Promise.all([
          this.$store.dispatch("loadPreparationSlipTemplates"),
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          })
        ]);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
